// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OfferResponse

import { OfferEngineType } from './enums.gen';
import { hydrateOfferSessionOrder, type OfferSessionOrder, type OfferSessionOrderApiResponse } from './offerSessionOrder.gen';
import { hydrateGuestPrice, type GuestPrice, type GuestPriceApiResponse } from './guestPrice.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type OfferApiResponse = {
	id: string;
	name: string;
	privateShortName: string;
	engine: OfferEngineType;
	isActive: boolean;
	sortOrder: number;
	presentation: string;
	shortDescription: string;
	color: string;
	followLogo: boolean;
	logo: string | null;
	bookingTimeBefore: number | null;
	reconfirmTimeBefore: number | null;
	basePrice: number;
	excludeOtherOffers: boolean;
	isPrivate: boolean;
	maxDuration: number | null;
	maxPax: number;
	minPax: number;
	maxBookingPerDay: number;
	maxBookingPerSession: number;
	maxFutureBookingTime: number | null;
	minBreakTimeBetweenSession: number;
	validityDates: string[] | null;
	validityStart: string | null;
	validityEnd: string | null;
	publishStart: string | null;
	publishEnd: string | null;
	allowFullOnlinePayment: boolean;
	allowOfflinePayment: boolean;
	allowDeposit: boolean;
	cancellationTimeBefore: number | null;
	depositPercent: number | null;
	depositPrice: number | null;
	depositPricePerPax: number | null;
	dammagePercent: number | null;
	dammagePrice: number | null;
	dammagePricePerPax: number | null;
	dammageEnabled: boolean;
	depositRequiredFrom: number | null;
	allowGuaranteedPayment: boolean;
	guaranteeRequiredFrom: number | null;
	guaranteePercent: number | null;
	guaranteePricePerPax: number | null;
	guaranteePrice: number | null;
	followSessionsOrder: boolean;
	sessionOrders: OfferSessionOrderApiResponse[];
	guestPrices: GuestPriceApiResponse[];
	collectionId: string;
	qrCodeEnabled: boolean;
	postBookingInfo: string;
	archivedAt: string | null;
};

export type Offer = {
	id: string;
	name: string;
	privateShortName: string;
	engine: OfferEngineType;
	isActive: boolean;
	sortOrder: number;
	presentation: string;
	shortDescription: string;
	color: string;
	followLogo: boolean;
	logo: string | null;
	bookingTimeBefore: number | null;
	reconfirmTimeBefore: number | null;
	basePrice: number;
	excludeOtherOffers: boolean;
	isPrivate: boolean;
	maxDuration: number | null;
	maxPax: number;
	minPax: number;
	maxBookingPerDay: number;
	maxBookingPerSession: number;
	maxFutureBookingTime: number | null;
	minBreakTimeBetweenSession: number;
	validityDates: string[] | null;
	validityStart: DateTime | null;
	validityEnd: DateTime | null;
	publishStart: DateTime | null;
	publishEnd: DateTime | null;
	allowFullOnlinePayment: boolean;
	allowOfflinePayment: boolean;
	allowDeposit: boolean;
	cancellationTimeBefore: number | null;
	depositPercent: number | null;
	depositPrice: number | null;
	depositPricePerPax: number | null;
	dammagePercent: number | null;
	dammagePrice: number | null;
	dammagePricePerPax: number | null;
	dammageEnabled: boolean;
	depositRequiredFrom: number | null;
	allowGuaranteedPayment: boolean;
	guaranteeRequiredFrom: number | null;
	guaranteePercent: number | null;
	guaranteePricePerPax: number | null;
	guaranteePrice: number | null;
	followSessionsOrder: boolean;
	sessionOrders: OfferSessionOrder[];
	guestPrices: GuestPrice[];
	collectionId: string;
	qrCodeEnabled: boolean;
	postBookingInfo: string;
	archivedAt: DateTime | null;
};

export function hydrateOffer(data: OfferApiResponse): Offer {
	return {
		...data,
		validityStart: DateTimefromISO(data.validityStart),
		validityEnd: DateTimefromISO(data.validityEnd),
		publishStart: DateTimefromISO(data.publishStart),
		publishEnd: DateTimefromISO(data.publishEnd),
		sessionOrders: data.sessionOrders.map(hydrateOfferSessionOrder),
		guestPrices: data.guestPrices.map(hydrateGuestPrice),
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}